import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const defaultFunction = () => { };

export default function AutoCompleteTextField({
  options,
  onChange = defaultFunction,
  getOptionLabel,
  value,
  isOptionEqualToValue,
  filterOptions,
  renderOption,
  renderTags,
  placeholder,
  label,
  onOpen,
  open,
  multiple,
  inputValue,
  loading = false,
  helperText,
  error = false,
  defaultValue,
  onInputChange,
  disabled = false,
  disableClearable = false,
  filterSelectedOptions = false,
  onClose = defaultFunction,
  ...props
}) {
  return (
    <Autocomplete
      open={open}
      multiple={multiple}
      onOpen={onOpen}
      inputValue={inputValue}
      filterSelectedOptions={filterSelectedOptions}
      onClose={onClose}
      id="multiple-limit-tags"
      options={options}
      value={value}
      loading={loading}
      onInputChange={onInputChange}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      disabled={disabled}
      isOptionEqualToValue={isOptionEqualToValue}
      filterOptions={filterOptions}
      renderOption={renderOption}
      renderTags={renderTags}
      disableClearable={disableClearable}
      defaultValue={defaultValue}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          placeholder={placeholder}
          label={label}
          helperText={helperText}
        />
      )}
      {...props}
    />
  );
}
